import { render, staticRenderFns } from "./CategoryMemberTab.vue?vue&type=template&id=6c5fa5d4"
import script from "./CategoryMemberTab.vue?vue&type=script&lang=js"
export * from "./CategoryMemberTab.vue?vue&type=script&lang=js"
import style0 from "./CategoryMemberTab.vue?vue&type=style&index=0&id=6c5fa5d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports